import React from 'react';
import { HotelContextInterface } from '../../types/HotelContextTypes';

// Create a context with no initial values.
export const HotelContext = React.createContext<HotelContextInterface | null>(null);

export default HotelContext;
